export default "__VITE_ASSET__df7e3e97__"